import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { rgba } from 'polished';
import { mq, useThemeContext } from '@/features/theme';
import { Header } from './header';
import { Hero } from './hero';
import { Body } from './body';
import { Footer } from './footer';

const BookingLayoutContainer = styled.div(() => {
  const theme = useThemeContext();

  return {
    padding: '40px 16px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    background: `linear-gradient(to bottom, ${rgba(theme.primaryColor, 0.1)}, transparent)`,

    [mq.sm]: { padding: '16px 0' },
  };
});

interface IBookingLayoutProps {
  className?: string;
}

export const BookingLayout = ({
  children,
  className,
}: PropsWithChildren<IBookingLayoutProps>) => {
  return (
    <BookingLayoutContainer className={className}>
      {children}
    </BookingLayoutContainer>
  );
};

BookingLayout.Header = Header;
BookingLayout.Hero = Hero;
BookingLayout.Body = Body;
BookingLayout.Footer = Footer;
